import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import buildingsData from "../../data/buildings.json";
import "./SecondStepSales.css";
import Nav from "../Nav/Nav";
import SalesSections from "../SalesSections/SalesSections";
import Footer from "../Footer/Footer";

const SecondStepSales = () => {
  const { buildingId } = useParams();
  const [building, setBuilding] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!buildingId || !buildingsData.length) return;

    const foundBuilding = buildingsData.find(
      (b) => String(b.building_id) === String(buildingId)
    );

    if (foundBuilding) {
      setBuilding(foundBuilding);
    } else {
      console.error(`Building with id ${buildingId} not found`);
    }
  }, [buildingId]);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  const getNextBuildingId = () => {
    if (!building || !buildingsData.length) return null;

    const currentIndex = buildingsData.findIndex(
      (b) => String(b.building_id) === String(building.building_id)
    );
    const nextIndex = (currentIndex + 1) % buildingsData.length;
    return buildingsData[nextIndex]?.building_id;
  };

  const getPrevBuildingId = () => {
    if (!building || !buildingsData.length) return null;

    const currentIndex = buildingsData.findIndex(
      (b) => String(b.building_id) === String(building.building_id)
    );
    const prevIndex =
      (currentIndex - 1 + buildingsData.length) % buildingsData.length;
    return buildingsData[prevIndex]?.building_id;
  };

  const handleNavigate = (targetBuildingId) => {
    if (targetBuildingId) {
      navigate(`/secondstep/${targetBuildingId}`);
    }
  };

  return (
    <>
      <div className="secondstepsales-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="secondstepsales-container">
          {getNextBuildingId() && (
            <button
              className="secondstepsales-next-button-outside"
              onClick={() => handleNavigate(getNextBuildingId())}
            >
              <img
                src="/nextup.png"
                alt="Next"
                className="secondstepsales-nextPro-btn-img"
              />
            </button>
          )}

          {getPrevBuildingId() && (
            <button
              className="secondstepsales-prevTop-button-outside"
              onClick={() => handleNavigate(getPrevBuildingId())}
            >
              <img
                src="/prevup.png"
                alt="Prev"
                className="secondstepsales-prevProTop-btn-img"
              />
            </button>
          )}

          {building && (
            <img
              src={building.building_image_url}
              alt={building.building_title || "Building"}
              className="secondstepsales-image"
            />
          )}

          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {"  "}
                <strong>
                  <span class="protest-font"></span>
                  <img
                    src="/underlined2-1.png"
                    alt="Underline decoration"
                    className="underline-image"
                  />
                </strong>{" "}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <SalesSections isAlbanian={isAlbanian} buildingId={buildingId} />
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default SecondStepSales;
